module.exports = __webpack_public_path__ + "img/Alerts.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Alerts.svg
// module id = 240
// module chunks = 0